module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQlJREFUWEftlcsRwjAMRFdFQBVUAS1QBdQDVdACVEEVUISIZhwmH2NJjp0cSI4ZW/u0ttaEhT9aWB8rwOrAfznAzFsARyK6ttM3mwNB/A5gB+DcQswCMBB/AjgQ0UtcqA6QEq8OoIlXBbCIVwOwilcB8IiPAJj51IzJrb2h3pcyIr4noneqzncKgvilCYremFghvJ2Pgii3gBSasreXAzmFcvZ0XR0FkaegZ+2vo4wmoeUyMfMGwCNke9a9SY5hCqKUuJoDMYhg5eTOzc9xpFvZK0+q2K7OuTbGptdwACE1i4irR9Cl70DI78mdm48gAgEtXjXbkzng2VxirekOlBByBVFNwWHt1YEPLWGeIfAIwzMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/ActivityModule/index/image/correct.png
// module id = 1565
// module chunks = 0